<template>
  <div v-if="firstStep" class="align-items-center text-center">
    <p style="margin-bottom: 10px; margin-top: 10px; font-weight: bold">
      {{ textStep }}
    </p>
  </div>

  <form
    v-if="firstStep"
    role="form"
    autocomplete="off"
    @submit.prevent="onSubmit"
  >
    <div class="row formContainer">
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
        v-if="selectedPlan === 'empresarial'"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Nombre de la Empresa
        </label>
        <input
          required
          placeholder="Nombre de la Empresa"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="companyName"
        />
      </div>

      <!-- <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
        v-if="selectedPlan === 'empresarial'"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >RUC
        </label>
        <input
          required
          placeholder="Nombres"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="dni"
        />
      </div> -->
      <!-- <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
        v-if="selectedPlan === 'personal'"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Cédula
        </label>
        <input
          required
          placeholder="Nombres"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="dni"
        />
      </div> -->
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Nombres
        </label>
        <input
          required
          placeholder="Nombres"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          maxlength="30"
          v-model="firstName"
        />
      </div>
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Apellidos
        </label>
        <input
          required
          placeholder="Apellidos"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="lastName"
          maxlength="30"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Número Celular (*):</label
        >

        <MazPhoneNumberInput
          type="tel"
          default-country-code="EC"
          :country-locale="phoneCountryLocale"
          :preferred-countries="preferredPhoneCountries"
          style="width: 100%"
          no-example
          required
          show-code-on-list
          size="sm"
          v-model="phoneNumber"
          @update="results = $event"
          :translations="{
            countrySelector: {
              placeholder: 'Código',
              error: 'Elija un pais',
            },
            phoneInput: {
              placeholder: 'Nro. celular',
              example: 'Ejemplo:',
            },
          }"
        />
      </div>

      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Correo electrónico (Opcional):</label
        >
        <input
          placeholder="Correo electrónico"
          class="form-control col-lg-12"
          type="email"
          autocomplete="off"
          v-model="email"
        />
      </div>

      <div style="justify-content: center; display: flex; margin: 20px 0 0 0">
        <button
          type="submit"
          id="btn_submit"
          class="btn btn-primary"
          :disabled="isDisabled"
          style="width: 100%"
        >
          Enviar
        </button>
      </div>
    </div>
  </form>
  <div v-if="thirdStep" class="resultContainer">
    <p
      style="
        color: #0c75ba;
        font-weight: 700;
        font-size: 18px;
        padding: 0 0 16px 0;
        text-align: center;
        margin: 0;
      "
    >
      ¡Registramos tu información exitosamente!
    </p>
    <p
      style="
        color: #333333;
        font-weight: 600;
        font-size: 16px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 0 0 10px 0;
      "
    >
      {{
        this.isDashboard
          ? "Muy pronto se contactará un ejecutivo comercial de Saludsa con tu referido."
          : "Muy pronto te contactará un ejecutivo comercial de Saludsa."
      }}
    </p>
    <!-- <p
      style="
        color: #333333;
        font-weight: 500;
        font-size: 14px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 10px 0 0 0;
        max-width: 370px;
        text-align: center;
      "
    >
      Ante cualquier duda o problema, no dudes en contactarte por
      <span style="color: #19b251; font-weight: 700">Whatsapp</span>

      con
      <span style="font-weight: 700">Servicio Al Cliente </span>
    </p> -->
    <!-- <button
      class="btn btn-primary"
      style="margin: 30px 0 0 0"
      @click="closeModal"
    >
      Entendido
    </button> -->
  </div>
  <div v-if="fourthStep" class="resultContainer">
    <p
      style="
        color: #0c75ba;
        font-weight: 700;
        font-size: 18px;
        padding: 0 0 16px 0;
        text-align: center;
        margin: 0;
      "
    >
      ¡Este referido ya está registrado!
    </p>
    <p
      style="
        color: #333333;
        font-weight: 600;
        font-size: 16px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 0 0 10px 0;
      "
    >
      Tu {{ this.isDashboard ? "referido" : "contacto" }}
      ha sido registrado y procesado anteriormente.
    </p>
    <!-- <p
      style="
        color: #333333;
        font-weight: 500;
        font-size: 14px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 10px 0 0 0;
        max-width: 370px;
        text-align: center;
      "
    >
      Ante cualquier duda o problema, no dudes en contactarte por
      <span style="color: #19b251; font-weight: 700">Whatsapp</span>

      con
      <span style="font-weight: 700">Servicio Al Cliente </span>
    </p> -->
    <!-- <button
      class="btn btn-primary"
      style="margin: 30px 0 0 0"
      @click="closeModal"
    >
      Entendido
    </button> -->
  </div>
  <div v-if="fifthStep" class="resultContainer">
    <p
      style="
        color: #0c75ba;
        font-weight: 700;
        font-size: 18px;
        padding: 0 0 16px 0;
        text-align: center;
        margin: 0;
      "
    >
      ¡Tu contacto ya se encuentra en revisión!
    </p>
    <p
      style="
        color: #333333;
        font-weight: 600;
        font-size: 16px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 0 0 10px 0;
      "
    >
      {{ this.pendingText }}
    </p>
    <!-- <p
      style="
        color: #333333;
        font-weight: 500;
        font-size: 14px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 10px 0 0 0;
        max-width: 370px;
        text-align: center;
      "
    >
      Ante cualquier duda o problema, no dudes en contactarte por
      <span style="color: #19b251; font-weight: 700">Whatsapp</span>

      con
      <span style="font-weight: 700">Servicio Al Cliente </span>
    </p> -->
    <!-- <button
      class="btn btn-primary"
      style="margin: 30px 0 0 0"
      @click="closeModal"
    >
      Entendido
    </button> -->
  </div>
  <div v-if="sixthStep" class="resultContainer">
    <p
      style="
        color: #0c75ba;
        font-weight: 700;
        font-size: 18px;
        padding: 0 0 16px 0;
        text-align: center;
        margin: 0;
      "
    >
      ¡Registramos tu información exitosamente!
    </p>
    <p
      style="
        color: #333333;
        font-weight: 600;
        font-size: 16px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 0 0 10px 0;
      "
    >
      {{ this.pendingText }}
    </p>
    <!-- <p
      style="
        color: #333333;
        font-weight: 500;
        font-size: 14px;
        padding: 10px 20px 0 20px;
        text-align: center;
        margin: 10px 0 0 0;
        max-width: 370px;
        text-align: center;
      "
    >
      Ante cualquier duda o problema, no dudes en contactarte por
      <span style="color: #19b251; font-weight: 700">Whatsapp</span>

      con
      <span style="font-weight: 700">Servicio Al Cliente </span>
    </p> -->
    <!-- <button
      class="btn btn-primary"
      style="margin: 30px 0 0 0"
      @click="closeModal"
    >
      Entendido
    </button> -->
  </div>
</template>

<script>
/*eslint-disable */

import ArgonSwitch from "../components/ArgonSwitch.vue";
import {
  PREFERRED_PHONE_COUNTRIES,
  PHONE_COUNTRY_LOCALE,
} from "@/constants/phoneCountries";

export default {
  name: "Venta",
  components: { ArgonSwitch },
  props: ["promoCode", "isDashboard"],
  data() {
    return {
      phoneCountryLocale: PHONE_COUNTRY_LOCALE,
      preferredPhoneCountries: PREFERRED_PHONE_COUNTRIES,
      isDisabled: false,
      displayName: null,
      firstName: null,
      lastName: null,
      companyName: null,
      step: 1,
      phoneNumber: null,
      firstStep: true,
      secondStep: false,
      thirdStep: false,
      fourthStep: false,
      fifthStep: false,
      sixthStep: false,
      pendingText: "",
      results: null,
      email: null,
      textStep: "Información general",
      identityVerified: false,
      selectedPlan: "personal",
      dni: null,
    };
  },
  methods: {
    sanitizeNameForTyping(value) {
      // IMPORTANT: don't trim while typing, otherwise the user can't type a
      // trailing space to start a second word (e.g. "JUAN ").
      return String(value ?? "")
        .replace(/[\r\n\t]+/g, " ")
        .replace(/\s+/g, " ")
        .slice(0, 30);
    },
    sanitizeNameForSubmit(value) {
      return this.sanitizeNameForTyping(value).trim();
    },
    onSubmit(event) {
      event.preventDefault();
      document.getElementById("btn_submit").innerHTML =
        '<i class="fas fa-spinner fa-pulse"></i>  Enviando solicitud...';

      this.isDisabled = true;

      const jsonData = {
        planType: this.selectedPlan,
        firstname: this.sanitizeNameForSubmit(this.firstName).toUpperCase(),
        lastname: this.sanitizeNameForSubmit(this.lastName).toUpperCase(),
        email: this.email,
        phone: this.phoneNumber,
        promoCode: this.promoCode,
      };

      this.$https
        .post("/hubspot/addContact", jsonData)
        .then((response) => {
          document.getElementById("btn_submit").innerHTML =
            '<i class="fas fa-spinner fa-pulse"></i>  Enviando solicitud...';
          this.isDisabled = false;
          if (response.status === 201) {
            this.thirdStep = true;
            this.firstStep = false;
            this.secondStep = false;
            this.textStep = "¡Tu información se envió exitosamente!";
            this.step = 3;

            this.$eventBus.emit("reiniciarListadoVentas");
          } else {
            this.$toast.error(response.data.message, {
              position: "top-right",
              max: 10,
            });
            document.getElementById("btn_submit").innerHTML = "Enviar";
            this.isDisabled = false;
          }
        })
        .catch((error) => {
          document.getElementById("btn_submit").innerHTML = "Enviar";
          this.isDisabled = false;

          // Handle specific error status codes
          if (error.response && error.response.status === 409) {
            this.step = 3;
            this.firstStep = false;
            this.secondStep = false;
            this.thirdStep = false;
            const errorMessage =
              error.response.data.error || "Error desconocido";
            if (
              errorMessage ===
              "El contacto ya se encuentra referido en nuestro sistema."
            ) {
              this.pendingText =
                "Tu contacto ha sido registrado y procesado por Saludsa anteriormente.";
              this.fourthStep = true;
            } else if (
              errorMessage ===
              "Contacto ya se encuentra en solicitud de aprobación."
            ) {
              this.pendingText =
                "Tu contacto está pendiente de aprobación y está siendo revisado, el proceso tomará hasta 24 horas.";
              this.fifthStep = true;
            } else if (errorMessage) {
              this.pendingText =
                "El contacto ingresado está pendiente de revisión, el proceso tomará hasta 24 horas.";
              this.sixthStep = true;
            }
            this.$toast.error(errorMessage, {
              position: "top-right",
              max: 10,
            });
          } else if (error.response && error.response.status === 400) {
            this.$toast.error(
              "Datos de entrada incompletos. Por favor, verifica que todos los campos estén completos.",
              {
                position: "top-right",
                max: 10,
              }
            );
          } else if (error.response && error.response.status === 404) {
            this.$toast.error(
              "Usuario no encontrado. Por favor, verifica tu código de promoción.",
              {
                position: "top-right",
                max: 10,
              }
            );
          } else if (error.response && error.response.status === 500) {
            this.$toast.error(
              "Error del servidor. Por favor, intenta nuevamente en unos minutos.",
              {
                position: "top-right",
                max: 10,
              }
            );
          } else if (
            error.code === "NETWORK_ERROR" ||
            error.message === "Network Error"
          ) {
            this.$toast.error(
              "Error de conexión. Por favor, verifica tu conexión a internet e intenta nuevamente.",
              {
                position: "top-right",
                max: 10,
              }
            );
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            this.$toast.error(error.response.data.error, {
              position: "top-right",
              max: 10,
            });
          } else {
            console.error("Unexpected error:", error);
            this.$toast.error(
              "Ocurrió un error inesperado. Por favor, intenta nuevamente.",
              {
                position: "top-right",
                max: 10,
              }
            );
          }
        });
    },

    atras() {
      if (this.step === 3) {
        this.step = 1;
        this.firstStep = true;
        this.secondStep = false;
        this.thirdStep = false;
        this.textStep = "Información general";
      }
    },

    closeModal() {
      this.$eventBus.emit("reiniciarFormVenta");
      this.$eventBus.emit("closeModalVenta");
    },
  },
  computed: {},
  watch: {
    results(newValue) {
      if (newValue.isValid) {
        this.phoneNumber = newValue.e164;
      }
    },
    firstName() {
      const v = this.sanitizeNameForTyping(this.firstName);
      this.firstName = v ? v.toUpperCase() : null;
    },
    lastName() {
      const v = this.sanitizeNameForTyping(this.lastName);
      this.lastName = v ? v.toUpperCase() : null;
    },
    email() {
      this.email = this.email.toLowerCase();
    },
  },
  mounted() {},
  created() {},
  beforeUnmount() {},
};
</script>

<style scoped>
.switchContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 16px 0 10px 0;
  gap: 12px;
}

.title {
  position: absolute;
  top: 0;
}
.switchContainer button.active {
  background-color: #0c75ba !important;
  color: white !important;
}

.switchContainer button {
  background-color: white !important;
  color: #0c75ba;
}

.formContainer {
  width: 100%;
}

@media (min-width: 1200px) {
  .formContainer {
    width: auto;
  }
}

@media (min-width: 1025px) and (max-width: 1200px) {
  .formContainer {
    width: auto;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .formContainer {
    width: auto;
  }
}

@media (min-width: 100px) and (max-width: 767px) {
  .formContainer {
    width: auto;
  }
}

.resultContainer {
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
}
</style>
